module.exports = __webpack_public_path__ + "img/02c9af3.png";